import axios from "../plugins/axios";

/**
 * The response body is `{ data: [...rows], locales: { active, base } }`.
 * `locales` is a SIBLING of `data`, not a settings row, so it is not reachable
 * through the theme/general getter -- returning `res.data.data` here dropped it
 * before the store ever saw it. Both keys are passed through instead, and
 * theme.module unpacks them.
 *
 * A backend predating the locales key sends `data` alone; that surfaces as
 * `locales: null`, which the activeLocales getter reports as an empty list.
 */
async function fetchAll() {
  const res = await axios.get("/qr-app/setting?group=" + process.env.VUE_APP_THEME_ID);
  const body = res && res.data ? res.data : {};
  return {
    data: Array.isArray(body.data) ? body.data : [],
    locales: body.locales ? body.locales : null,
  };
}

// Unused, kept as a re-export. Delegates so the two can never return different
// shapes -- the bug above was one function's return value being reshaped alone.
async function getAll() {
  return fetchAll();
}


const settingService = {
  getAll,
  fetchAll,
};

export default settingService;
